export const ReportsModel = {
    totalSales: "0",
    totalItems: 0,
    totalOrders: 0,
    totalTkw: { orders: 0, total: 0 },
    totalDelivery: { orders: 0, total: 0 },
    totalOnsite: { orders: 0, total: 0 },
    cashPayments: { orders: 0, total: 0 },
    onlinePayments: { orders: 0, total: 0 },
    totalShipping: 0,
    totalTips: 0,
    totalCoupons: 0,
}